export interface StateToValuePhoneFormatterOptions {
  options?: {
    forceSeparator?: boolean;
  };
}

const stateToValuePhoneFormatter = (value: string, { options: { forceSeparator } = {} }: StateToValuePhoneFormatterOptions = {}) => {
  if (!value) {
    return '';
  }

  const matches = String(value).match(/^([(+ ]*)([0-9]{0,3})([- ()_+.]*)([0-9]{0,3})([- ()_+.]*)([0-9]*)$/);

  if (matches) {
    // eslint-disable-next-line prefer-const
    let [, s1, n1, s2, n2, s3, n3] = matches;

    if (forceSeparator) {
      s1 = '';
    }

    if (forceSeparator || (n1 && !s2 && n2)) {
      s2 = ' ';
    }

    if (forceSeparator || (n2 && !s3 && n3)) {
      s3 = '-';
    }

    return [s1, n1, s2, n2, s3, n3].join('');
  }

  return value;
};

export default stateToValuePhoneFormatter;
